export default __webpack_public_path__ + "static/media/component-126-11@3x.16bdb879.png";